import { lazyNamed } from 'src/utils/lazyNamed.ts';

const TagDetails = {
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  DisableRuleList: lazyNamed(() => import('./containers/DisableRuleList/index.tsx'), 'DisableRuleList'),
  DynamicPlacementsList: lazyNamed(() => import('./containers/DynamicPlacementsList/index.tsx'), 'DynamicPlacementsList'),
  DynamicPlacementHistory: lazyNamed(() => import('./containers/DynamicPlacementHistory/index.tsx'), 'DynamicPlacementHistory'),
  PlacementsList: lazyNamed(() => import('./containers/PlacementsList/index.tsx'), 'PlacementsList'),
  PlacementsHistory: lazyNamed(() => import('./containers/PlacementsHistory/index.tsx'), 'PlacementsHistory'),
  Placement: lazyNamed(() => import('./containers/Placement/index.tsx'), 'Placement'),
  Changelog: lazyNamed(() => import('./containers/Changelog/index.tsx'), 'Changelog'),
  BiddersAssign: lazyNamed(() => import('./containers/BiddersAssign/index.tsx'), 'BiddersAssign'),
  RawScriptsList: lazyNamed(() => import('./containers/RawScriptsList/index.tsx'), 'RawScriptsList'),
  FloorRule: lazyNamed(() => import('./containers/FloorRule/index.tsx'), 'FloorRule'),
  FloorRuleHistory: lazyNamed(() => import('./containers/FloorRuleHistory/index.tsx'), 'FloorRuleHistory'),
  RawScriptHistory: lazyNamed(() => import('./containers/RawScriptHistory/index.tsx'), 'RawScriptHistory'),
  FloorExperiments: lazyNamed(() => import('./containers/FloorExperiments/index.tsx'), 'FloorExperiments'),
  RealtimeAnalytics: lazyNamed(() => import('./containers/RealtimeAnalytics/index.tsx'), 'RealtimeAnalytics'),
  PlacementLive: lazyNamed(() => import('./containers/PlacementLive/index.tsx'), 'PlacementLive'),
  PlacementLayout: lazyNamed(() => import('./components/PlacementLayout.tsx'), 'PlacementLayout'),
  Logbook: lazyNamed(() => import('./containers/Logbook/index.tsx'), 'Logbook'),
};

export default TagDetails;
